/**
 * 在指定索引位置插入一个数组到另一个数组中
 * @param arr 目标数组
 * @param index 插入位置的索引
 * @param arrayToInsert 要插入的数组
 * @returns 插入后的新数组
 */
export function getInsertArray<T>(
  arr: Array<T>,
  index: number,
  arrayToInsert: Array<T>,
): Array<T> {
  // 检查索引是否在数组长度范围内
  if (index > arr.length || index < 0) {
    return arr;
  }
  // 使用splice方法在指定索引位置插入arrayToInsert数组
  arr.splice(index, 0, ...arrayToInsert);
  return arr;
}
